import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/pro-solid-svg-icons'
import { placeIcon, withinText } from './place-chip'

// What a page is narrowed to, as removable chips (owner 2026-10-09): each
// chip says what the list keeps ("Only Trevor", "Test Assistant and
// everything in it", "Only EdXR Editor") and its × takes that one off;
// "Show everything" takes them all off.
//
// parts: [{ key, text, code?, title?, node?, icon?, remove }], remove the
// filters patch that takes the part off. onRemove(part), onClear().
export const ActiveFilters = ({ parts, onRemove, onClear }) => {
  if (!parts || parts.length === 0) return null
  return (
    <div className="au-pivot au-active" role="status" aria-label="Narrowed">
      <span className="au-active-label">Showing only</span>
      <ul className="au-active-chips">
        {parts.map(p =>
          <li key={p.key} className="au-active-chip">
            {p.icon && <FontAwesomeIcon icon={p.icon} className="au-active-icon" aria-hidden="true" />}
            <span className="au-active-text" title={p.title}>{p.node || <>{p.text}{p.code ? <> <code>{p.code}</code></> : null}</>}</span>
            <button type="button" className="au-active-x" aria-label={`Remove ${p.label || p.text}${p.code ? ` ${p.code}` : ''}`} onClick={() => onRemove(p)}>
              <FontAwesomeIcon icon={faXmark} aria-hidden="true" />
            </button>
          </li>)}
      </ul>
      <button type="button" className="btn btn-link btn-sm p-0 au-linkbtn" onClick={onClear}>Show everything</button>
    </div>
  )
}

// The within filter's chip. place: the node as the page knows it (its name
// and type: content's first page names it, or the chip the reader clicked);
// unknown, it reads "this course or folder".
export const withinPart = (within, place) => {
  if (!within) return null
  const name = (place && place.name) || 'This course or folder'
  return { key: 'within', text: withinText(name), label: withinText(name), icon: placeIcon(place && place.type), remove: { within: '' } }
}
